import { parse } from 'query-string';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { ReactComponent as UserIcon } from '../../../assets/svg/account.svg';
// icons
import { ReactComponent as CartIcon } from '../../../assets/svg/cart.svg';
import { ReactComponent as HomeIcon } from '../../../assets/svg/home.svg';
import { ReactComponent as ServiceIcon } from '../../../assets/svg/serviceCenter.svg';
import { ReactComponent as WalletIcon } from '../../../assets/svg/wallet.svg';
import { BaseURL } from '../../../base/env';
import { Wallet } from '../Wallet/Wallet';
import FooterItemWrapper from './FooterItemWrapper';

const Footer = () => {
  const history = useHistory();
  const location = useLocation();
  const store = useSelector((state) => state);
  const parsedQueries = parse(location.search);

  const footerList = [
    {
      onClick: () => {
        const href =
          BaseURL === 'https://api.carfillo.com'
            ? 'http://sc.carfillo.com/'
            : BaseURL === 'https://dev.api.carfillo.com'
              ? 'http://dev.sc.carfillo.com/'
              : 'http://172.172.60.225:3001/';
        window.location = href;
      },
      icon: ServiceIcon,
      alt: 'ServiceIcon',
      thick: true,
      label: 'خدمات',
      isCard: false
    },
    {
      onClick: () => {
        if (store.Login.is_login) {
          history.push(`${location.pathname}?action=show-wallet`);
        } else {
          history.push('/login/');
        }
      },
      icon: WalletIcon,
      alt: 'کیف پول',
      label: 'کیف پول',
      condition: parsedQueries?.action === 'show-wallet',
      isCard: false
    },

    {
      toPage: '/#top',
      icon: HomeIcon,
      alt: 'homeicon',
      label: 'خانه',
      condition: location.pathname === '/' && parsedQueries?.action !== 'show-wallet',
      isCard: false
    },
    {
      toPage: store.Login.is_login ? '/profile/' : '/login/d/',
      icon: UserIcon,
      alt: 'usericon',
      label: 'حساب کاربری',
      condition:
        (location.pathname === '/profile/' || location.pathname === '/profile/edit/') &&
        parsedQueries?.action !== 'show-wallet',
      isCard: false
    },
    {
      toPage: '/cart/',
      icon: CartIcon,
      alt: 'carticon',
      label: 'سبد خرید',
      thick: true,
      condition:
        history.location.pathname === '/cart/' || store.Login?.cart_data?.total_quantity > 0,
      isCard: true
    }
  ];

  return (
    <div className="component-footer">
      {footerList.map((footerItem, i) => (
        <FooterItemWrapper
          key={i}
          footerItem={footerItem}
          showWallet={parsedQueries.action === 'show-wallet'}>
          <footerItem.icon
            className={`footer-icon ${footerItem.thick ? 'thick' : ''} ${
              footerItem.condition ? 'active' : ''
            }`}
          />
          <label className={`footer-item-label ${footerItem.condition ? 'active' : ''}`}>
            {footerItem.label}
          </label>
          {footerItem.isCard ? (
            store.Login?.cart_data?.total_quantity ? (
              <span className="footer-cart-quantity">
                <span className="footer-cart-quantity-text">
                  {store.Login?.cart_data?.total_quantity}
                </span>
              </span>
            ) : null
          ) : null}
        </FooterItemWrapper>
      ))}
      <Wallet
        closePopup={() => history.push(location.pathname)}
        show={parsedQueries.action === 'show-wallet'}
      />
    </div>
  );
};

export default Footer;
